import React from 'react';
import BaseModal from 'components/Modals/BaseModal';
import styled from 'styled-components';
import StyledReactButton from 'components/Buttons/StyledButton';

type PropTypes = {
  children: JSX.Element;
  isOpen: boolean;
  onToggle: () => void;
  title: string;
  leftButtonText?: string;
  rightButtonText: string;
  onLeft?: () => void;
  onRight: () => void;
  rightButtonColor?: string;
  size?: 'sm' | 'lg' | 'xlg' | '2xlg' | '3xlg';
};

const ConfirmModal: React.FunctionComponent<PropTypes> = ({
  children,
  isOpen,
  onToggle,
  title,
  leftButtonText,
  rightButtonText,
  onLeft,
  onRight,
  rightButtonColor,
  size = 'sm',
}) => (
  <BaseModal isOpen={isOpen} onToggle={onToggle} title={title} size={size}>
    <>
      <ConfirmMessage>{children}</ConfirmMessage>
      <ButtonWrapper>
        {leftButtonText && (
          <LeftButton
            color="secondary"
            onClick={() => {
              onToggle();
              if (onLeft) onLeft();
            }}
          >
            {leftButtonText}
          </LeftButton>
        )}
        <RightButton
          color={rightButtonColor ? rightButtonColor : 'primary'}
          onClick={() => {
            onToggle();
            onRight();
          }}
        >
          {rightButtonText}
        </RightButton>
      </ButtonWrapper>
    </>
  </BaseModal>
);

const ConfirmMessage = styled.div`
  margin-bottom: 12px;
`;
const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  text-align: right;
`;
const LeftButton = styled(StyledReactButton)`
  margin-right: 8px;
`;
const RightButton = styled(StyledReactButton)`
  align-self: flex-end;
`;

export default ConfirmModal;
